import {Translate} from "../Translate";

const supplierRoutes = [
    {
        id: 'dashboard',
        title: Translate.dashboard,
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
    },
    {
        id: 'tickets',
        title: Translate.tickets,
        type: 'item',
        icon: 'chat',
        url: '/tickets',
        roles: ['user','supplier','admin','product_manager','support'],
        feature:'tickets'
    },

    {
        id: 'wallet',
        title: Translate.myWallet,
        type: 'item',
        icon: 'account_balance_wallet',
        url: '/wallet/view',
        feature: 'wallet'
    },
    {
        id: 'accounting',
        title: Translate.accountingReport,
        type: 'item',
        icon: 'description',
        url: '/accounting-report',
        roles: ['supplier','admin'],
    },
    {
        id: 'shop_orders',
        roles: ['supplier','admin','product_manager','support'],
        title: Translate.shopOrders,
        type: 'item',
        icon: 'receipt',
        url: '/shop-orders',
    },
    {
        id: 'my_shop',
        title: Translate.myShop,
        type: 'item',
        icon: 'store',
        url: '/my-shop',
        roles: ['supplier','admin','product_manager','support'],
        feature: 'marketplace'
    },
    {
        id: 'my_shop',
        title: Translate.shopDiscounts,
        type: 'item',
        icon: 'confirmation_number',
        url: '/vendor/discounts',
        roles: ['supplier'],
        feature: 'marketplace'
    },
    {
        id: 'festivals',
        title: Translate.festivals,
        type: 'item',
        icon: 'festival',
        url: '/festivals',
        roles: ['supplier','admin','product_manager','support'],
    },

    {
        id: 'modify_pricing',
        title: Translate.productsList,
        type: 'item',
        icon: 'price_change',
        roles: ['supplier','admin','product_manager','support'],
        url: '/modify-pricing',
    },
    {
        id: 'productsList',
        title: Translate.myBooks,
        type: 'item',
        icon: 'shopping_cart',
        url: '/my-products',
        roles: ['supplier','admin','product_manager','support'],
        feature: 'marketplace'
    },
    {
        id: 'bulck_pricing',
        title: Translate.bulkPricingShort,
        type: 'item',
        icon: 'table_rows',
        roles: ['supplier','admin','product_manager','support'],
        url: '/pricing/bulk',
    },
    {
        id: 'transfer_pricing',
        title: Translate.transferPricing,
        type: 'item',
        icon: 'local_shipping',
        roles: ['supplier','admin','product_manager','support'],
        url: '/transfer-pricing',
    },

    {
        id: 'account',
        title: Translate.account,
        type: 'group',
    },
    {
        id: 'myDetails',
        title: Translate.myDetails,
        type: 'collapse',
        icon: 'person',
        children: [
            {
                id: 'addresses',
                title: Translate.addresses,
                type: 'item',
                icon: 'map',
                url: '/account/address',
            },
            {
                id: 'settings',
                title: Translate.account,
                type: 'item',
                icon: 'person',
                url: '/account/details',
            },

            {
                id: 'verification',
                title: Translate.verificationDetails,
                icon: 'credit_card',
                type: 'item',
                url: '/account/verification',
                feature:"wallet"
            },
            {
                id: 'password',
                title: Translate.changePassword,
                icon: 'password',
                type: 'item',
                url: '/account/password',
            },
        ],
    },
    {
        id: 'fileManager',
        title: Translate.fileManager,
        type: 'item',
        icon: 'image',
        url: '/file-manager',
        roles: ['admin','support','supplier','product_manager'],
        permission: "fileManagerPage",
    },
/*    {
        id: 'manageTemplate',
        title: Translate.manageTemplate,
        type: 'item',
        icon: 'format_paint',
        url: '/manage/template',
        roles: ['admin'],
    },*/

];
export default supplierRoutes;
